import {Loader, useReachGoalCallback} from '@yandex-delivery/blocks'
import React, {useEffect} from 'react'
import {fetchSharedRouteInfo} from 'src/api'
import {isAuthMode} from 'src/shared/config'

import {useEventsPollingAuth, useSharedRoteInfoPolling, useSharedRoute} from '../../hooks'
import {MarginProvider} from '../margin-provider'
import {ActiveScreen, ActiveScreenAuth, CompleteScreen, CompleteScreenAuth} from '../screens'

const Screen = isAuthMode ? ActiveScreenAuth : ActiveScreen
const ErrorScreen = isAuthMode ? CompleteScreenAuth : CompleteScreen

type Props = {
  sharingKey: string
}

const SharedRoute: React.FC<Props> = ({sharingKey}) => {
  const [{payload, error}, startTransition] = useSharedRoute()
  const reachGoal = useReachGoalCallback()
  const info = payload?.body

  const triggerRefresh = React.useCallback(() => {
    startTransition(() => fetchSharedRouteInfo({key: sharingKey}))
  }, [sharingKey, startTransition])

  useSharedRoteInfoPolling(sharingKey)
  useEventsPollingAuth(sharingKey, triggerRefresh)

  useEffect(() => {
    reachGoal('OpenSharedRoute', {sharingKey})
  }, [reachGoal, sharingKey])

  if (error) {
    return <ErrorScreen />
  }

  if (info) {
    return (
      <MarginProvider>
        <Screen info={info} />
      </MarginProvider>
    )
  }

  return <Loader />
}

export default SharedRoute
